<template>
  <v-menu
    v-model="isOpen"
    :close-on-content-click="false"
    offset-y
    left
  >
    <template #activator="{ on, attrs }">
      <v-btn
        color="primary"
        outlined
        small
        :ripple="false"
        :disabled="disabled"
        class="mr-2"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          left
          small
        >
          {{ icons.mdiClockOutline }}
        </v-icon>
        終了一括設定
      </v-btn>
    </template>

    <v-card width="360">
      <v-card-title class="text-subtitle-1">
        終了時刻の一括設定
      </v-card-title>
      <v-card-subtitle>
        対象: {{ roleLabel ? `${roleLabel}の全勤怠行` : '表示中の全勤怠行' }}(ページ送り分を含む)
      </v-card-subtitle>

      <v-card-text>
        <v-text-field
          v-model="time"
          label="終了時刻"
          type="time"
          dense
          class="pt-1"
          :hint="crossingMidnight ? '営業日を跨ぐ時刻は翌日日付で保存されます' : ''"
          :persistent-hint="crossingMidnight"
        />
        <v-radio-group
          v-model="scope"
          dense
          hide-details
          class="mt-6"
        >
          <v-radio
            value="emptyOnly"
            :label="`終了が未入力の行のみ(${emptyCandidates.length}件)`"
          />
          <v-radio
            value="all"
            :label="`全員に上書き(${candidates.length}件)`"
          />
        </v-radio-group>
        <p
          v-if="scope === 'all'"
          class="warning--text text-caption mt-3 mb-0"
        >
          入力済みの終了時刻も置き換えられます
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :ripple="false"
          @click="isOpen = false"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="primary"
          :ripple="false"
          :disabled="!time || applyCount === 0"
          @click="onApply"
        >
          適用({{ applyCount }}件)
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mdiClockOutline } from '@mdi/js'
import useCurrentData from '@/views/composable/useCurrentData'
import { clubTimeOf, isClubCrossingMidnight } from '@/views/composable/useTimecardBusinessDate'

export default {
  name: 'BulkSetLeaveAtMenuButton',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    roleLabel: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { currentClub } = useCurrentData()
    const isOpen = ref(false)
    const time = ref('')
    const scope = ref('emptyOnly')

    // 仮想行(タイムカード未作成)は一括設定の対象外
    const candidates = computed(() => props.items.filter(item => !item.meta.isVirtual && item.startAt))
    const emptyCandidates = computed(() => candidates.value.filter(item => !item.leaveAt))
    const applyCount = computed(() => (scope.value === 'all' ? candidates.value.length : emptyCandidates.value.length))

    const crossingMidnight = computed(() => isClubCrossingMidnight(currentClub.value))

    const defaultTime = () => clubTimeOf(currentClub.value, 'closeAt') || ''

    watch(isOpen, opened => {
      if (opened && !time.value) time.value = defaultTime()
    })

    const onApply = () => {
      emit('apply', { time: time.value, overwrite: scope.value === 'all' })
      isOpen.value = false
    }

    return {
      isOpen,
      time,
      scope,
      candidates,
      emptyCandidates,
      applyCount,
      crossingMidnight,
      onApply,

      icons: {
        mdiClockOutline,
      },
    }
  },
}
</script>
